import * as React from 'react';


//Mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { BarChart } from '@mui/x-charts/BarChart';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme } from '@mui/material/styles';

//Custom
import API_CONSTANTS from '../resources/constants/api.json';
import {NOTICE_TABLE_CONSTANTS} from '../resources/constants/NoticeTableConstants';
import {APPROVAL_OPTIONS} from '../resources/constants/FiveDayTableConstants';
import {downloadFile} from '../resources/utils/commonFunctions.js';


export default function DashboardComponent(props) {
    const useState = React.useState;
    const useEffect = React.useEffect;
    const theme = useTheme();
    const [pdfRunning, setPDFRunning] = useState(false);
    const [statusDataLabels, setStatusDataLabels] = useState([]);
    const [statusDataCount, setStatusDataCount] = useState([]);
    const [missingFees, setMissingFees] = useState();
    const [dnsCount, setDNSCount] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState([]);
    const [serviceDate, setServiceDate] = useState();
    const [fileList, setFileList] = useState([]);
    const [notices, setNotices] = useState(props.rowJson.filter(r => {
        if (['approved','admin_approved'].includes(r.status_text)) {return r}
    }));
    const [loading, setLoading] = useState(false);
    const [mailToList, setMailToList] = useState(true);

    const rowJson = props.rowJson;

    useEffect(()=>{
        fetch(`${API_CONSTANTS.API_ROUTE}/getAllUsers`)
        .then(
            (response)=>{
                response.json().then(data => {
                    let users = data.filter(d => d.is_active === 1 && 
                        (d.can_approve === 1 || d.can_deliver === 1))
                    setUserData(users)
                })
            }
        )
    },[])
    
    useEffect(()=>{
        if (rowJson.length > 0){
            statusData();
            iconData();
        }
    },[rowJson])

    const iconData = () => {
        console.log('rowJson',rowJson)
        setMissingFees(rowJson.filter(r => r.feeAmount === null).length);
        setDNSCount(rowJson.filter(r => r.DoNotServe === 1).length);
    }

    const requestPDF = async (fileName) => {
            const response = await fetch(`${API_CONSTANTS.API_ROUTE}/getPDF?fileName=${fileName}`);
            const data = await response.json();
            downloadFile(data.file, fileName, 'application/pdf');
        }
    
    const getPDFs = () => {
        setPDFRunning(true)
        fetch(`${API_CONSTANTS.API_ROUTE}/getNoticeDocs?runDate=${props.runDate}&serviceDate=${serviceDate}&mailToList=${mailToList}`)
        .then(
            (response)=>{
                response.json().then((data) => {
                    // downloadFile(data.labelBytes, props.runDate + '_labels.pdf', 'application/pdf');
                    // downloadFile(data.pdfBytes, props.runDate + '_notices.pdf', 'application/pdf');
                    data.forEach(async (record) => {
                        await requestPDF(record.files);
                        await requestPDF(record.labels);
                    })

                    setPDFRunning(false)
                })
            }
        )
    }

    const updateAssignmentStatus = async (row, assignmentId) => {
        try {
            let loadingTimeout = setTimeout(()=>{setLoading(true)}, 250)
            let assignmentEmail = userData.filter(a => a.id === assignmentId)[0].email
            let response = await fetch(`${API_CONSTANTS.API_ROUTE}/updateAssignment`,{
                method:"POST",
                headers: { 'Content-Type': 'application/json'},                
                body:JSON.stringify({
                    assignment: assignmentId,
                    obid: row.id,
                    run_date: props.runDate,
                    user_id: props.userInfo._id,
                    email: assignmentEmail,
                    lease_id: row.Accountnumber
                })
            })
            if (response.status === 200) {
                const updatedNotices = notices.map(r => {
                    if (r.Accountnumber === row.Accountnumber){
                        r.assigned_to = assignmentId
                    }
                    return r
                });
                setNotices(updatedNotices);
                clearTimeout(loadingTimeout)
                setLoading(false)
                return { ok: true };
            } else {
                setLoading(false)
            }
            
            throw new Error(`HTTP error! status: ${response.status}`);
            
        } catch (error) {
            console.error('Error updating status:', error);
            return { ok: false, error };
        }
    };

    const statusData = () => {
        let newStatusData = [{value:null,label:null,},...APPROVAL_OPTIONS].map((r)=>{
            let count = rowJson.filter(record => record.status_text === r.value).length;
            r.count = count;
            r.name = r.label;
            return r;
        })
        let nulls = newStatusData.filter(r => r.label === null)[0];
        newStatusData = newStatusData.map((r)=>{
            if (r.label === 'Not Set'){
                r.count = r.count + nulls.count
            }
            return r
        })
        newStatusData = newStatusData.slice(1,6);
        setStatusDataLabels(newStatusData.map(l =>  l.label.substring(0,10)))
        setStatusDataCount(newStatusData.map(c =>  c.count))
    }

    const statusBarChart = () => {
        return (

            <BarChart
                xAxis={[{
                    scaleType: 'band',
                    data: statusDataLabels  }]}
                series={[{data:  statusDataCount}]}
                colors={[theme.palette.info.main, theme.palette.success.main, theme.palette.warning.main, theme.palette.secondary?.main || theme.palette.primary.main, theme.palette.error.main]}
                width={500}
                height={250}
            />
        )
    }

    const iconBarChart = () => {
        return (
            <BarChart
                xAxis={[{
                    scaleType: 'band',
                    data: ['No Notice Fee', 'Do Not Serve']  }]}
                series={[{data: [missingFees, dnsCount]}]}
                colors={[theme.palette.success.main, theme.palette.secondary?.main || theme.palette.primary.main]}
                width={500}
                height={250}                
            />
        )
    }

    const assignmentChart = () => {
        if (!userData[0]){
            return
        }
        let categorized = Object.groupBy(notices, ({assigned_to}) => assigned_to);
        let counts = []
        try{
        console.log('assignmentChart',Object.keys(categorized),userData)
        Object.keys(categorized).forEach(k=>{
            // let userName = userData.filter( u => u.id == k)
            let userName = k != 'null' ? 
                userData.filter(u => u.id == parseInt(k))[0].email.split('@')[0] :
                "Unassigned"
            counts.push({
                userName: userName,
                count: categorized[k].length
            })
        })
        return (
            <BarChart
                xAxis={[{ 
                    scaleType: 'band', 
                    data: counts.map(r => r.userName)  }]}
                series={[{data: counts.map(c => c.count)}]}
                // colors={[Colors.c_vp_green, Colors.c_vp_purple]}
                width={500}
                height={250}                
            />
        )}
        catch(err){
            console.log('err 211 dashboardcomponent',err)
            return (<Skeleton color="red"></Skeleton>)
        }
    }


    return (
        <Box sx={{ bgcolor: theme.palette.background.default, height: '99vh', width: '100%' }}>

            <Modal
                open={modalOpen}
                onClose={()=>{setModalOpen(false);}}
                >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: theme.palette.background.paper,
                    border: '2px solid #000',
                    borderRadius: 2,
                    boxShadow: 24,
                    margin: "0",
                    padding: 15,
                    textAlign: "center",
                    width: "50%",
                    height: "67%"}}>
                    <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 99 })}
                    open={loading}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                        <DataGrid
                            sx={(theme) => ({
                                fontSize:12,
                                '& .MuiDataGrid-row': {
                                    borderBottom: '1px solid',
                                    borderColor: theme.palette.divider,
                                    '&:hover': {
                                        backgroundColor: theme.palette.action.hover,
                                    },
                                },
                                '& .MuiDataGrid-cell': {
                                    borderBottom: '1px solid',
                                    borderColor: theme.palette.divider,
                                },
                                backgroundColor: theme.palette.background.paper,
                            })}
                            rows={notices}
                            loading={!notices || !userData}
                            slots={{ toolbar: GridToolbar }}
                            slotProps={{
                                loadingOverlay: {
                                variant: 'linear-progress',
                                noRowsVariant: 'linear-progress',
                                },
                                toolbar: {
                                    showQuickFilter: true,
                                },
                            }}
                            getRowID={(row)=>row.Accountnumber}
                            columns={NOTICE_TABLE_CONSTANTS(updateAssignmentStatus, userData, props.userInfo)}
                            initialState={{
                            pagination: {
                                paginationModel: {
                                pageSize: 10,
                                },
                            },
                            }}
                            pageSizeOptions={[5,6,7,8,9,10]}
                        />
                </Box>
            </Modal>
            <Grid container spacing={0}>
                <Grid 
                    display="flex"
                    size={{ xs: 8, md: 6 }}
                    alignItems="flex-start"
                    justifyContent="center">
                    <Box
                    display="flex"
                    flexDirection={"column"}
                    alignItems="center"
                    justifyContent="center">
                        <Typography>Potential Notices by Approval Status</Typography>
                        {statusDataLabels.length > 0 ? 
                            statusBarChart() : 
                            <Skeleton />}
                    </Box>
                </Grid>
                <Grid 
                    display="flex"
                    size={{ xs: 8, md: 6 }}
                    alignItems="flex-start"
                    justifyContent="center">
                    <Box
                    display="flex"
                    flexDirection={"column"}
                    alignItems="center"
                    justifyContent="center">
                        <Typography>Tenants without notice fees</Typography>
                        {missingFees ? iconBarChart() : <Skeleton />}
                    </Box>
                </Grid>
                <Grid 
                    display="flex"
                    size={{ xs: 8, md: 6 }}
                    alignItems="flex-start"
                    justifyContent="center">
                    <Box
                    display="flex"
                    flexDirection={"column"}
                    alignItems="center"
                    justifyContent="center">
                        <Typography>Notice assignments</Typography>
                        {notices && userData ? assignmentChart() : <Skeleton />}
                    </Box>
                </Grid>
                <Grid 
                    display="flex"
                    size={{ xs: 8, md: 6 }}
                    alignItems="center"
                    justifyContent="center">
                    <Stack direction={"column"} spacing={2}>
                        <Button 
                            onClick={()=>setModalOpen(true)}
                            sx={{height:"75px",width:"200px", fontSize:"100%", fontWeight:"bold"}}
                            variant="contained">
                            Assign Notices
                        </Button>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker label="ServiceDate" 
                                onChange={(dt)=>{
                                    setServiceDate(dt.toJSON().split('T')[0])
                                }}
                            />
                        </LocalizationProvider>
                        <Stack direction={"row"} spacing={2}>
                        <Button
                            disabled={!serviceDate || pdfRunning}
                            onClick={getPDFs}
                            disableElevation
                            disableRipple={!serviceDate || pdfRunning}
                            sx={{
                                height:"75px",
                                width:"200px",
                                fontSize:"100%",
                                fontWeight:"bold",
                                '&.Mui-disabled': {
                                    color: theme.palette.mode === 'dark' ?
                                    'rgba(0, 0, 0, 0.5)' :
                                    'rgba(255, 255, 255, .5)',
                                    background: theme.palette.action.disabledBackground,
                                    cursor: 'not-allowed',
                                    pointerEvents: 'auto',
                                },
                                '&.Mui-disabled:hover': {
                                    background: theme.palette.action.disabledBackground
                                }
                            }}
                            variant="contained">
                            <Stack>
                                <Box sx={{width:'100%'}}>Get 5 Days</Box>
                                {pdfRunning && <Box sx={{width:'100%'}}><LinearProgress /></Box>}
                            </Stack>
                        </Button>
                        
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={mailToList}
                                    onChange={(e) => setMailToList(e.target.checked)}
                                    color="primary"
                                />
                                }
                                label="Send to List"
                            />

                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
